import { render, staticRenderFns } from "./ArrivaStatistics.vue?vue&type=template&id=e565cd86&scoped=true"
import script from "./ArrivaStatistics.vue?vue&type=script&lang=js"
export * from "./ArrivaStatistics.vue?vue&type=script&lang=js"
import style0 from "./ArrivaStatistics.vue?vue&type=style&index=0&id=e565cd86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e565cd86",
  null
  
)

export default component.exports